const VEHICLES_URL = 'https://platform.suzuki-motor.ru/catalog/vehicles/';

export const fetchVehicles = async () => {
  const res = await fetch(VEHICLES_URL);
  const vehicles = await res.json();
  return vehicles;
};
